import React from 'react';
import { MapPin, Phone, Clock, Users, ExternalLink, Navigation } from 'lucide-react';
import { BRANCHES, GROUP_IMAGE, CLASSROOM_IMAGE, TEACHER_IMAGE } from '../data/mock';

export default function Campus() {
  const gallery = [GROUP_IMAGE, CLASSROOM_IMAGE, TEACHER_IMAGE];
  return (
    <div className="fade-in">
      <section className="coral-gradient text-white relative overflow-hidden">
        <div className="absolute inset-0 dotted-bg opacity-60" />
        <div className="relative max-w-7xl mx-auto px-5 sm:px-8 py-20 lg:py-28">
          <div className="text-white/90 text-xs font-semibold uppercase tracking-[0.18em]">Our Campus</div>
          <h1 className="font-serif font-semibold text-5xl md:text-6xl mt-4 leading-[1.05] max-w-4xl">
            Two campuses across <span className="gold-text italic">Kolkata & Howrah.</span>
          </h1>
          <p className="mt-6 text-white/90 text-lg max-w-2xl">Bright classrooms, dedicated faculty, and a calm environment built for focused learning.</p>
        </div>
      </section>

      <section className="max-w-7xl mx-auto px-5 sm:px-8 py-20">
        <div className="grid md:grid-cols-3 gap-4">
          {gallery.map((src, i) => (
            <div key={src} className={`rounded-3xl overflow-hidden shadow-xl ${i === 0 ? 'md:col-span-2' : ''}`}>
              <img src={src} alt={`Campus ${i+1}`} className="w-full h-[440px] object-cover" />
            </div>
          ))}
        </div>

        {/* Branch cards with embedded maps */}
        <div className="mt-16">
          <h2 className="font-serif text-4xl md:text-5xl font-semibold leading-tight text-center">Visit us at <span className="italic text-amber-600">either branch.</span></h2>
          <p className="text-stone-600 mt-3 text-center max-w-2xl mx-auto">Get directions, call us, or just drop in for a campus tour during admission hours.</p>

          <div className="grid lg:grid-cols-2 gap-8 mt-12">
            {BRANCHES.map((b) => (
              <div key={b.name} className="bg-white rounded-3xl border border-orange-100 overflow-hidden shadow-coral smooth card-hover">
                <div className="aspect-[16/10] w-full overflow-hidden bg-stone-100">
                  <iframe
                    title={`${b.name} location`}
                    src={b.mapEmbed}
                    width="100%"
                    height="100%"
                    style={{ border: 0 }}
                    loading="lazy"
                    referrerPolicy="no-referrer-when-downgrade"
                    allowFullScreen
                  />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-3 mb-2">
                    <div className="w-11 h-11 rounded-xl bg-coral-light text-coral flex items-center justify-center">
                      <MapPin className="w-5 h-5" />
                    </div>
                    <h3 className="font-serif font-semibold text-2xl">{b.name}</h3>
                  </div>
                  <p className="text-stone-600 mt-2 leading-relaxed">{b.address}</p>

                  <div className="grid grid-cols-2 gap-4 mt-5 pt-5 border-t border-orange-100">
                    <div>
                      <div className="text-xs uppercase tracking-wider text-stone-500 font-semibold flex items-center gap-1.5"><Clock className="w-3.5 h-3.5"/> Hours</div>
                      <div className="text-sm text-stone-700 mt-1">Mon–Sat · 9 AM – 8 PM</div>
                    </div>
                    <div>
                      <div className="text-xs uppercase tracking-wider text-stone-500 font-semibold flex items-center gap-1.5"><Users className="w-3.5 h-3.5"/> Batches</div>
                      <div className="text-sm text-stone-700 mt-1">Small groups · 12–20</div>
                    </div>
                  </div>

                  <div className="flex flex-wrap gap-2 mt-5">
                    <a href={`tel:${b.tel}`} className="btn-primary smooth font-medium px-5 py-2.5 rounded-xl inline-flex items-center gap-2">
                      <Phone className="w-4 h-4" /> {b.phone}
                    </a>
                    <a href={b.mapLink} target="_blank" rel="noreferrer" className="bg-white border border-orange-200 hover:bg-coral-light smooth font-medium px-5 py-2.5 rounded-xl text-stone-800 inline-flex items-center gap-2">
                      <Navigation className="w-4 h-4 text-coral" /> Get directions <ExternalLink className="w-3.5 h-3.5 opacity-60" />
                    </a>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}
